import { createStore } from 'vuex'

const Store = createStore({
    state () {
        return {
            token:""

        }
    },
    getters: {
        isLogin: (state) => {
           let token=sessionStorage.getItem("token")
           if(token==""||token==undefined){
            state.token=""
           }else{
            state.token=token
           }
           
            return state.token.length > 0
        }
    },
    mutations: {
        clearUserInfo(state) {
            state.token = "";
            sessionStorage.setItem("token","")
        },
        registUserInfo(state,{token}) {
            state.token = token;
            sessionStorage.setItem("token",token)
        }
    }
})

export default Store;